import { ThumbDown, ThumbUp, ThumbsUpDown } from '@mui/icons-material';
import { SENTIMENT } from '../constants';

function getOverallSentimentConfig({ type }) {
  let color = 'info';
  let text = '-';
  let Icon = null;

  if (type === SENTIMENT.POSITIVE) {
    color = 'success';
    text = 'Positive';
    Icon = ThumbUp;
  } else if (type === SENTIMENT.NEGATIVE) {
    color = 'error';
    text = 'Negative';
    Icon = ThumbDown;
  } else if (type === SENTIMENT.NEUTRAL) {
    color = 'warning';
    text = 'Neutral';
    Icon = ThumbsUpDown;
  }

  return { color, text, Icon };
}

export default getOverallSentimentConfig;
